import React from 'react';
import type { ElementType, ReactElement, ReactNode } from 'react';

import classnames from 'classnames';

import { Overflow } from '../../../Overflow/Overflow';
import { useBreadcrumbContext } from '../../Breadcrumb.context';

import styles from './BreadcrumbItems.module.scss';

type BreadcrumbItemsProps = {
    className?: string;
    children?: ReactNode;
    as?: ElementType;
};

export const BreadcrumbItems = ({
    className,
    children,
    as = 'ol'
}: BreadcrumbItemsProps): ReactElement => {
    const { overflow } = useBreadcrumbContext();
    return (
        <Overflow as={as} overflow={overflow} className={classnames(styles.container, className)}>
            {children}
        </Overflow>
    );
};
